
import React from "react";
import { Settings } from "lucide-react";

const ConfiguracoesHeader = () => {
  return (
    <div className="flex flex-col mb-6">
      <div className="flex items-center mb-4">
        <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-blue-600 mr-3 shadow-sm">
          <Settings className="h-5 w-5 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-gray-800 mb-1">Configurações Financeiras</h1>
          <p className="text-sm text-gray-500 mt-1">
            Gerencie as configurações do sistema financeiro
          </p>
        </div>
      </div>
      <div className="h-1 w-24 bg-blue-600 rounded-full opacity-75"></div>
    </div>
  );
};

export default ConfiguracoesHeader;
